import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, } from 'react-redux';
import { assigned_userActions } from '../../actions';
import { CheckIcon, UserAvatar } from '../../components'

const AssignUserCheckboxGroup = ({ name, options,  input, meta: { touched, error }, ...rest}) => {
  const dispatch = useDispatch();
  const changeGuardRef = useRef(false);

  return(
    <>
      {options && options.length > 0 ?
          options.map((option, index) => {
            return(
              <div className="dropdown-item with-checkbox checkbox" key={index}>
                <label className="d-flex align-items-center">
                  <div 
                    className={`
                      d-flex align-items-center justify-content-center
                      rounded-checkbox
                      rounded-checkbox--${input.value.indexOf(option.id) !== -1 ? 'checked' : 'unchecked'}
                      me-1
                    `}
                  >
                    {input.value.indexOf(option.id) !== -1 && (
                      <CheckIcon color="white" height={10} width={12} />
                    )}
                  </div>

                  <div className='assigned-user-checkbox__info d-flex align-items-center'>
                    <UserAvatar
                      icon={ option.logo.url && option.logo.icon.url ? option.logo.icon.url : null }
                      name={ option.first_name + " " + option.last_name }
                      name_initials={ option.name_initials }
                      size="22"
                      cached={false}
                      className="me-1"
                    />

                    <div>
                      <div className="assigned-user-checkbox__name">
                        {option.first_name} {option.last_name}
                        {!option.first_name && !option.last_name ? option.email : ""}
                      </div>

                      <div className='assigned-user-checkbox__role'>
                        {option.role_name ? <div className="proper-text">{option.role_name}</div> : null}
                      </div>
                    </div>


                  </div>

                  <input type="checkbox"
                    name={`${input.name}_user_id`}
                    value={option.id}
                    checked={input.value.indexOf(option.id) !== -1}
                    className='d-none'
                    onChange={(event) => {
                      // prevent handling the same change multiple times in quick succession
                      if (changeGuardRef.current) return;
                      changeGuardRef.current = true;
                      try {
                        const newValue = [...input.value];
                        if (event.target.checked) {
                          newValue.push(option.id);
                        } else {
                          newValue.splice(newValue.indexOf(option.id), 1);
                          dispatch(assigned_userActions.uncheckdValue({ user_id: option.id, _destroy: true}));
                        }
                        input.onChange(newValue);
                      } finally {
                        // reset guard on next tick
                        setTimeout(() => { changeGuardRef.current = false; }, 0);
                      }
                    }}
                  />

                </label>
              </div>
            )
          })
        :
        null
      }
    </>
  )
}

export default AssignUserCheckboxGroup;
